import { render } from "./index.vue?vue&type=template&id=3cef545a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3cef545a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cef545a"],['__file',"src/components/BaseUi/LoadingModal/src/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cef545a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cef545a', __exports__)) {
    api.reload('3cef545a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3cef545a&scoped=true", () => {
    api.rerender('3cef545a', render)
  })

}


export default __exports__